import { HrisIntegrationType } from "@src/types.generated";

const HRIS_INTEGRATION_TYPE_OVERRIDES: Partial<
  Record<HrisIntegrationType, string>
> = {
  [HrisIntegrationType.SevenShifts]: "7shifts",
};

export function getHrisIntegrationTypeDisplayName(
  type: HrisIntegrationType | null | undefined,
): string {
  if (!type) return "--";
  return HRIS_INTEGRATION_TYPE_OVERRIDES[type] ?? type;
}
